import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Dialog, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTheme } from '@mui/material/styles';
import ErrorIcon from '../../public/ErrorIcon.svg';
import { useThemeDetails } from './ThemeDetailsContext';
import { constants } from '../constants';
const _modalHandler = {
    fn: (open, payload) => {
        console.log(open, payload); // placeholder; overridden by the mounted component
    }
};
const handleApiErrorModal = (open, payload) => {
    _modalHandler.fn(open, payload);
};
const ApiErrorModal = () => {
    const theme = useTheme();
    const { stateImages } = useThemeDetails();
    const [open, setOpen] = useState(false);
    const [payload, setPayload] = useState({
        title: '',
        description: ''
    });
    const [copied, setCopied] = useState(false);
    const handleOpen = useCallback((isOpen, next) => {
        setPayload(next);
        setOpen(isOpen);
    }, []);
    useEffect(() => {
        _modalHandler.fn = handleOpen;
        return () => {
            _modalHandler.fn = (open, payload) => console.log(open, payload);
        };
    }, [handleOpen]);
    const handleClose = () => {
        setOpen(false);
        setCopied(false);
    };
    const handleCopy = () => {
        if (payload.refId) {
            navigator.clipboard.writeText(payload.refId).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        }
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, PaperProps: {
            sx: {
                backgroundColor: theme.palette.background.paper,
                borderRadius: '24px',
                boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.12), 0px 4px 8px 0px rgba(0,0,0,0.14)',
                padding: 0,
                width: '500px',
                overflow: 'hidden'
            }
        }, sx: {
            '& .MuiDialog-paper': { overflow: 'hidden' },
            '& .MuiDialog-container': { overflow: 'hidden' }
        }, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    px: '24px',
                    pt: '32px',
                    pb: '8px',
                    width: '100%'
                }, children: _jsxs(Stack, { spacing: 2, alignItems: "center", sx: { width: '100%' }, children: [_jsx(Box, { component: "img", src: stateImages?.Error || ErrorIcon, alt: constants.api_error_modal_icon_alt, sx: {
                                width: stateImages?.Error ? 117 : 78,
                                height: stateImages?.Error ? 117 : 78
                            } }), _jsx(Typography, { variant: "h6", sx: {
                                fontFamily: 'Open Sans',
                                fontWeight: 600,
                                fontSize: '20px',
                                lineHeight: '32px',
                                letterSpacing: '0.15px',
                                color: theme.palette.text.primary,
                                textAlign: 'center'
                            }, children: payload.title }), _jsx(Typography, { variant: "body1", sx: {
                                fontFamily: 'Open Sans',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0.15px',
                                color: theme.palette.text.primary,
                                textAlign: 'center',
                                whiteSpace: 'pre-wrap'
                            }, children: payload.description }), payload.refId && (_jsxs(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                borderRadius: '8px',
                                px: '16px',
                                py: '10px',
                                backgroundColor: theme.palette.background.default
                            }, children: [_jsxs(Typography, { variant: "body2", sx: {
                                        fontFamily: 'Open Sans',
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        letterSpacing: '0.1px',
                                        wordBreak: 'break-all'
                                    }, children: [constants.api_error_modal_ref_prefix, ' ', payload.refId] }), _jsx(Tooltip, { title: copied
                                        ? constants.api_error_modal_copied_tooltip
                                        : constants.api_error_modal_copy_tooltip, placement: "top", children: _jsx(IconButton, { size: "small", onClick: handleCopy, sx: { ml: 1, flexShrink: 0 }, children: _jsx(ContentCopyIcon, { fontSize: "small" }) }) })] }))] }) }), _jsx(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    px: '24px',
                    py: '24px',
                    width: '100%'
                }, children: _jsx(Button, { variant: "outlined", onClick: handleClose, sx: {
                        height: '44px',
                        px: '20px',
                        borderColor: theme.palette.error.main,
                        color: theme.palette.error.main,
                        '&:hover': {
                            borderColor: theme.palette.error.main,
                            backgroundColor: `${theme.palette.error.main}1A`
                        }
                    }, children: _jsx(Typography, { variant: "button", sx: {
                            fontSize: '16px',
                            lineHeight: '26.88px',
                            letterSpacing: '0.4px',
                            textTransform: 'none'
                        }, children: constants.close }) }) })] }));
};
export { handleApiErrorModal };
export default ApiErrorModal;
